<template>
  <div class="conversion-progress-container">
    <div
      v-for="task in activeTasks"
      :key="task.id"
      class="conversion-task"
      :class="{
        'task-completed': task.status === 'completed',
        'task-error': task.status === 'error'
      }"
    >
      <div class="task-header">
        <div class="task-info">
          <v-icon small :color="getIconColor(task.status)">{{ getIcon(task.status) }}</v-icon>
          <span class="task-name">{{ task.name }}</span>
        </div>
        <div class="task-actions">
          <span class="task-percent">{{ task.progress }}%</span>
          <v-btn
            icon
            x-small
            @click="removeTask(task.id)"
            v-if="task.status === 'completed' || task.status === 'error'"
          >
            <v-icon small>close</v-icon>
          </v-btn>
        </div>
      </div>

      <v-progress-linear
        :value="task.progress"
        :color="getProgressColor(task.status)"
        height="4"
        class="task-progress"
      ></v-progress-linear>

      <div class="task-message" v-if="task.message">
        {{ task.message }}
      </div>
    </div>
  </div>
</template>

<script>
import { conversionEventBus } from '@/services';

export default {
  name: 'ConversionProgressBar',
  data() {
    return {
      activeTasks: []
    };
  },
  mounted() {
    conversionEventBus.$on('conversion:start', this.addTask);
    conversionEventBus.$on('conversion:progress', this.updateTaskProgress);
    conversionEventBus.$on('conversion:complete', this.completeTask);
    conversionEventBus.$on('conversion:error', this.errorTask);
  },
  beforeDestroy() {
    conversionEventBus.$off('conversion:start', this.addTask);
    conversionEventBus.$off('conversion:progress', this.updateTaskProgress);
    conversionEventBus.$off('conversion:complete', this.completeTask);
    conversionEventBus.$off('conversion:error', this.errorTask);
  },
  methods: {
    addTask(taskData) {
      const task = {
        id: taskData.id || Date.now(),
        name: taskData.name || 'Converting video',
        progress: 0,
        status: 'processing',
        message: taskData.message || 'Converting H.265 to H.264...'
      };
      this.activeTasks.push(task);
    },

    updateTaskProgress(data) {
      const task = this.activeTasks.find(t => t.id === data.id);
      if (task) {
        task.progress = data.progress;
        if (data.message) task.message = data.message;
      } else {
        console.warn('Task not found:', data.id);
        console.log(
          'Available task IDs:',
          this.activeTasks.map(t => t.id)
        );
      }
    },

    completeTask(data) {
      const task = this.activeTasks.find(t => t.id === data.id);
      if (task) {
        task.progress = 100;
        task.status = 'completed';
        task.message = data.message || 'Conversion completed successfully!';

        setTimeout(() => {
          this.removeTask(task.id);
        }, 5000);
      }
    },

    errorTask(data) {
      const task = this.activeTasks.find(t => t.id === data.id);
      if (task) {
        task.status = 'error';
        task.message = data.message || 'Conversion failed';

        setTimeout(() => {
          this.removeTask(task.id);
        }, 10000);
      }
    },

    removeTask(taskId) {
      const index = this.activeTasks.findIndex(t => t.id === taskId);
      if (index !== -1) {
        this.activeTasks.splice(index, 1);
      }
    },

    getIcon(status) {
      switch (status) {
        case 'processing':
          return 'hourglass_empty';
        case 'completed':
          return 'check_circle';
        case 'error':
          return 'error';
        default:
          return 'info';
      }
    },

    getIconColor(status) {
      switch (status) {
        case 'processing':
          return 'blue';
        case 'completed':
          return 'green';
        case 'error':
          return 'red';
        default:
          return 'grey';
      }
    },

    getProgressColor(status) {
      switch (status) {
        case 'processing':
          return 'blue';
        case 'completed':
          return 'green';
        case 'error':
          return 'red';
        default:
          return 'grey';
      }
    }
  }
};
</script>

<style scoped>
.conversion-progress-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
  max-width: 400px;
  width: 100%;
}

.conversion-task {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 16px;
  margin-bottom: 12px;
  transition: all 0.3s ease;
}

.conversion-task.task-completed {
  background: #f1f8f4;
  border-left: 4px solid #4caf50;
}

.conversion-task.task-error {
  background: #fef5f5;
  border-left: 4px solid #f44336;
}

.task-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.task-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.task-name {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.task-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.task-percent {
  font-size: 13px;
  font-weight: 600;
  color: #666;
}

.task-progress {
  margin: 8px 0;
}

.task-message {
  font-size: 12px;
  color: #666;
  margin-top: 4px;
}

@media (max-width: 600px) {
  .conversion-progress-container {
    right: 10px;
    left: 10px;
    max-width: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ConversionProgressBar.vue